import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'
import { showPopupParts, setCarSelectedParts } from '../../../../../actions/price'
import { formatCurrency, reverseFormatCurrency } from '../../../../../utils/currency'
import { translation } from '../../../../../utils/helpers'
// import styles

// Elements
import Button from '../../../../elements/button'
import Check from '../../../../elements/check'
import Text from '../../../../elements/text'
import Inline from '../../../../elements/inline'
import Grid from '../../../../elements/grid'
import PanelHeader from '../../../../elements/panelHeader'
import Divider from '../../../../elements/divider'
import Icon from '../../../../elements/icon'

import { ElementIcons } from '../../../../elements/icons'

class ExtentList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedParts: [],
      inputs: [],
      inputsOriginal: [],
      carParts: [],
      priceParts: [],
      selectedPart: {},
      selectedBodyPart: undefined,
      showPopupForParts: this.props.showPopupForParts === true,
      selectedPartsOriginal: []
    }
    this.addNewInput = this.addNewInput.bind(this)
    this.close = this.close.bind(this)
    this.manualTaskId = 9000000000000000
    this.manualSpareTaskId = 9000000010000000
    this.findTaskFromTextId = this.findTaskFromTextId.bind(this)
  }
  componentDidMount () {
    this.reset.bind(this)
    this.init(this.props)
  }

  componentWillUnmount () {
    this.reset()
  }
  getBlankTask (part) {
    this.manualTaskId++
    return {
      id: part + '_extra_' + this.manualTaskId,
      AE: 0,
      EstimationExtraId: this.manualTaskId,
      IsSelected: false,
      Material: 0,
      Name: '',
      SortIndex: null
    }
  }
  reset (props) {
    this.manualTaskId = 9000000000000000
    this.setState({
      selectedParts: [],
      inputs: [],
      inputsOriginal: [],
      carParts: [],
      priceParts: [],
      selectedPart: {},
      selectedBodyPart: typeof (props) === 'undefined' ? undefined : props.selectedBodyPart,
      showPopupForParts: typeof (props) === 'undefined' ? false : props.showPopupForParts === true,
      selectedPartsOriginal: []
    })
  }
  componentWillReceiveProps (nextProps) {
    if (this.props.showPopupForParts !== nextProps.showPopupForParts ||
      this.props.selectedBodyPart !== nextProps.selectedBodyPart ||
      this.props.selectedBodyPartSide !== nextProps.selectedBodyPartSide || this.props.isPaint !== nextProps.isPaint) {
      if (nextProps.showPopupForParts) {
        this.init(nextProps)
      } else {
        this.reset(nextProps)
      }
    }
  }
  formatCurrencies (e) {
    if (e.SparePartPrice !== null) e.SparePartPrice = formatCurrency(parseFloat(reverseFormatCurrency(e.SparePartPrice)))
    if (e.AE !== null) e.AE = formatCurrency(parseFloat(reverseFormatCurrency(e.AE)), 1)
    if (e.Gross !== null) e.Gross = formatCurrency(parseFloat(e.Gross))
  }
  init (props) {
    const filterParts = (val) => {
      return props.selectedBodyPart.indexOf(val.Part.MappingName) > -1 && isEqual(val.Part.TaskSide, props.selectedBodyPartSide)
    }
    const filterCarParts = (val) => {
      return val.Mapping === props.selectedBodyPart
    }
    const createCarPartMapping = (part, partItemId, taskSide) => {
      let carParts = []
      let list = !props.isPaint ? JSON.parse(JSON.stringify(part.BodyTasks)) : JSON.parse(JSON.stringify(part.Tasks))
      let tasks = this.state.orderTasks // part.Tasks
      list.forEach((e) => {
        if (e !== undefined) {
          if (!props.isPaint) this.formatCurrencies(e)
          if (e.OrderTaskId === undefined && e.TaskId !== undefined) {
            let foundTask = false
            for (let key in tasks) {
              let task = tasks[key]
              if (!props.isPaint) this.formatCurrencies(task)
              if (e.TaskId === task.TaskPriceId) {
                task.FromOrderPrice = true
                task.IsSelected = true
                carParts.push(task)
                foundTask = true
                break
              }
            }
            if (!foundTask) {
              carParts.push(this.getInputFromPart(e, partItemId, taskSide))
            }
          } else if (e.OrderTaskId !== undefined) {
            let item = JSON.parse(JSON.stringify(e))
            if (!props.isPaint) this.formatCurrencies(item)
            carParts.push(item)
          }
        }
      })
      tasks.forEach((e) => {
        let item = JSON.parse(JSON.stringify(e))
        if (!props.isPaint) this.formatCurrencies(item)
        if (item.OrderTaskId > 0 && item.TaskPriceId === 0) {
          item.IsSelected = true
          item.name = this.state.selectedBodyPart + '_' + item.OrderTaskId + '_text'
          carParts.push(item)
        }
      })
      return carParts
    }
    if (props.showPopupForParts !== true) return null
    this.reset(props)
    let parts = JSON.parse(JSON.stringify(props.carPriceParts))
    parts = parts.filter(filterParts)
    let part = parts[0]
    let carParts = JSON.parse(JSON.stringify(props.carParts))
    carParts = carParts.filter(filterCarParts)
    let carPart = carParts[0]
    this.setState({
      selectedBodyPart: props.selectedBodyPart,
      showPopupForParts: props.showPopupForParts === true,
      orderTasks: typeof (part) !== 'undefined' ? part.Tasks : []
    }, () => {
      if (part === undefined) {
        part = carPart
      }
      if (!props.isPaint) {
        part.BodyTasks = JSON.parse(JSON.stringify(carPart.BodyTasks))
        if (part !== undefined) {
          if (part.PartId === undefined) part.PartId = part.Part.PartItemId
          if (part.TaskSide === undefined) part.TaskSide = part.Part.TaskSide
          part.BodyTasks = createCarPartMapping(part, part.PartId, part.TaskSide)
        }
      } else {
        part.Tasks = JSON.parse(JSON.stringify(carPart.Tasks))
        if (part !== undefined) {
          if (part.PartId === undefined) part.PartId = part.Part.PartItemId
          if (part.TaskSide === undefined) part.TaskSide = part.Part.TaskSide
          part.Tasks = createCarPartMapping(part, part.PartId, part.TaskSide)
        }
      }
      this.setState({
        selectedBodyPart: props.selectedBodyPart,
        showPopupForParts: props.showPopupForParts === true,
        selectedPartsOriginal: props.showPopupForParts === true ? JSON.parse(JSON.stringify(this.props.carSelectedParts)) : [],
        selectedParts: props.showPopupForParts === true ? JSON.parse(JSON.stringify(this.props.carSelectedParts)) : [],
        inputs: props.isPaint ? JSON.parse(JSON.stringify(part.Tasks)) : part !== undefined ? part.BodyTasks !== undefined ? JSON.parse(JSON.stringify(part.BodyTasks)) : JSON.parse(JSON.stringify(part.Tasks)) : [],
        inputsOriginal: props.isPaint ? JSON.parse(JSON.stringify(part.Tasks)) : part !== undefined ? part.BodyTasks !== undefined ? JSON.parse(JSON.stringify(part.BodyTasks)) : JSON.parse(JSON.stringify(part.Tasks)) : [],
        selectedPart: part,
        priceParts: JSON.parse(JSON.stringify(props.carPriceParts)),
        carParts: props.carParts
      }, () => {
        // console.log('CarPopup init state', this.state.inputs)
        if (this.shouldPushOther(this.state.inputs, this.manualTaskId, false)) this.addNewInput(this.manualTaskId, false)
        if (!this.props.isPaint && this.shouldPushOther(this.state.inputs, this.manualSpareTaskId, true)) this.addNewInput(this.manualSpareTaskId, true)
      })
    })
  }

  getInputFromPart (task, partItemId, taskSide) {
    let newTask = this.getInput(task.TaskId, task.TaskName, partItemId, taskSide, true, task.TaskId)
    newTask.IsNew = true
    if (!this.props.isPaint) {
      newTask.AE = task.AE
      newTask.Gross = task.TaskPrice
      this.formatCurrencies(newTask)
    }
    return newTask
  }

  getInput (id, taskName, partItemId, taskSide, fromOrderPrice, taskPriceId = 0) {
    let newInput = {
      AE: 0,
      AgreementDiscount: 0,
      Discount: 0,
      EnvAfterDiscountWP: 0,
      Environment: 0,
      EnvironmentAfterDiscount: 0,
      EnvironmentWP: 0,
      Gross: 0,
      GrossWP: 0,
      IsDeleted: false,
      Mat: 0,
      Net: 0,
      NetWP: 0,
      OrderTaskId: id,
      PartItemId: partItemId,
      TaskName: taskName,
      TaskPriceId: taskPriceId,
      TaskSide: taskSide,
      Total: 0,
      TotalWP: 0,
      IsSelected: false,
      FromOrderPrice: fromOrderPrice,
      SparePartCount: '',
      SparePartPrice: '',
      IsSparePart: false,
      name: this.state.selectedBodyPart + '_' + id + '_text'
    }
    return newInput
  }

  addNewInput (id, isSpare) {
    let { inputs } = this.state
    let { selectedPart } = this.state
    if (selectedPart === undefined) return null
    let newInput = this.getInput(id, '', selectedPart.PartId, selectedPart.TaskSide, false)
    newInput.IsNew = true
    newInput.IsSparePart = isSpare
    if (isSpare) newInput.SparePartCount = 1
    inputs.push(newInput)
    this.setState({
      inputs: inputs
    })
  }
  shouldPushOther (inputs, id, isSpare) {
    let notPermittet = [1, 5, 10]
    if (notPermittet.indexOf(Number(window.carHandler.priceCalcType)) > -1) return false
    return this.findTask(inputs, id, isSpare) === undefined
  }
  findTask (inputs, id, isSpare) {
    for (var i = 0; i < inputs.length; i++) {
      var item = inputs[i]
      if (isSpare !== undefined && item.OrderTaskId === id && item.IsSparePart === isSpare) {
        return item
      }
      if (isSpare === undefined && item.OrderTaskId === id) {
        return item
      }
    }
    return undefined
  }

  findTaskFromTextId (textId) {
    let id = textId.replace('_text', '').replace(this.props.selectedBodyPart + '_', '')
    id = Number(id)
    let { inputs } = this.state
    let task = this.findTask(inputs, id)
    return task
  }

  render () {
    if (this.props.showPopupForParts !== true) return null
    let notPermitted = [1, 5, 10]
    if (notPermitted.indexOf(Number(window.carHandler.priceCalcType)) > -1) return null
    let priceText = translation('641')
    let currencyCode = translation(this.props.currencyCode)
    let currencyText = priceText + ' (' + currencyCode + ')'
    // const renderLineHeading = (icon, text) => {
    //   if (this.props.price.Department !== 1) return null

    //   return (
    //     <div className='title'>
    //       <div className='icon titleIcon'>
    //         <img src={icon} />
    //       </div>
    //       {translation(text)}
    //       <span />
    //     </div>
    //   )
    // }
    const renderHeadings = () => {
      if (this.props.price.Department !== 1) return null
      return (
        <Grid spacing={1} cols={[1.30, 0.35, 0.35]}>
          <span />
          <div className='ae'>{translation('13345')}</div>
          <div className='price'>{currencyText}</div>
        </Grid>
      )
    }
    let part = this.props.selectedBodyPart
    // Default price calculation
    if (typeof this.state.inputs === 'undefined' || this.state.inputs.length === 0) {
      return null
    }
    const findPropName = (name) => {
      let notName = ['ae', 'partCount', 'partPrice', 'price']
      let index = notName.indexOf(name)
      switch (index) {
        case 0: return 'AE'
        case 1: return 'SparePartCount'
        case 2: return 'SparePartPrice'
        case 3: return 'Gross'
        default: return 'TaskName'
      }
    }
    const change = (e) => {
      let prop = findPropName(e.target.name)
      let { inputs } = this.state
      let task = this.findTaskFromTextId(e.target.id)
      let oldValue = task[prop]
      let newValue = e.target.value
      let isSpare = task.IsSparePart
      if (prop !== 'TaskName') { // make sure it is a number
        if (prop === 'SparePartCount') {
          newValue = Number(newValue)
          if (isNaN(newValue)) newValue = oldValue
        }
      }
      task[prop] = newValue
      task.IsSelected = true
      this.setState({
        inputs: inputs
      })
      let id = e.target.id.replace('_text', '').replace(this.props.selectedBodyPart + '_', '')
      id = Number(id)
      id++
      let nextTask = this.findTask(inputs, id, isSpare)
      if (nextTask === undefined && id < (isSpare ? this.manualSpareTaskId : this.manualTaskId)) {
        id = isSpare ? this.manualSpareTaskId : this.manualTaskId
        id++
        nextTask = this.findTask(inputs, id, isSpare)
      }
      let id2 = Number(e.target.id.replace('_text', '').replace(this.props.selectedBodyPart + '_', ''))
      if (nextTask === undefined && this.shouldPushOther(this.state.inputs, id, isSpare) && isEqual(id2, isSpare ? this.manualSpareTaskId : this.manualTaskId)) {
        this.addNewInput(id, isSpare)
        if (isSpare) {
          this.manualSpareTaskId++
        } else {
          this.manualTaskId++
        }
      }
    }
    const onBlur = (e) => {
      let prop = findPropName(e.target.name)
      if (prop === 'TaskName') return null
      let { inputs } = this.state
      let task = this.findTaskFromTextId(e.target.id)
      if (prop !== 'SparePartCount') {
        let oldValue = parseFloat(reverseFormatCurrency(task[prop]))
        let newValue = formatCurrency(oldValue)
        task[prop] = newValue
      }
      if (prop === 'SparePartCount' || prop === 'SparePartPrice') {
        let gross = 0
        if (task.SparePartCount > 0) {
          gross = task.SparePartCount * parseFloat(reverseFormatCurrency(task.SparePartPrice))
        }
        task.Gross = formatCurrency(gross)
        task.Net = task.Gross
      }
      this.setState({
        inputs: inputs
      })
    }
    const checkChange = (e) => {
    }
    const click = (e) => {
      let id = e.target.name.replace('_text', '').replace(this.props.selectedBodyPart + '_', '')
      let { inputs } = this.state
      let task = this.findTask(inputs, Number(id))
      let index = inputs.indexOf(task)
      inputs.splice(index, 1, task)
      task.IsSelected = e.target.value === 'false'
      this.setState({
        inputs: inputs
      })
    }
    const renderPartHeadings = () => {
      if (this.props.price.Department !== 1) return null
      return (
        <Grid cols={[2.1, 1.15, 0.25, 1, 1]} spacing={1}>
          <span />
          <div className='spareprice'>{translation('14833')}</div>
          <span />
          <div className='ae'>{translation('385')}</div>
          <div className='price'>{currencyText}</div>
        </Grid>
      )
    }
    const mapSpareInputs = (value, key) => {
      // let { inputs } = this.state
      let task = value // this.findTask(inputs, Number(value.OrderTaskId))
      var id = part + '_' + task.OrderTaskId
      var textVal = task.TaskName
      let isSelected = task.IsSelected
      // let specialClassName = 'carSpecialText row clearfix newcarrow'
      // let labelText = ''
      let inputName = id + '_text'
      let partCount = task.SparePartCount
      let sparePrice = task.SparePartPrice
      let cost = task.Gross
      let idkey = '' + task.OrderTaskId
      // let leftClass = 'leftcontent sixty'
      // let rightClass = 'rightcontent fourty'
      return (
        <div>
          <Grid key={idkey} cols={['min-content', 1, 0.75, 'min-content', 1.25]} align='center' spacing={1}>
            <Check simple name={id} id={id} value={isSelected} checked={isSelected} onChange={checkChange} onClick={click} />
            <Text size='s' className='carTextInput spare' name={inputName} id={inputName} value={textVal} placeholder={translation('227')} onChange={change.bind(this)} onBlur={onBlur.bind(this)} />
            <Text size='s' className='partprice' name='partPrice' id={id} value={sparePrice} placeholder={translation('14833')} onChange={change.bind(this)} onBlur={onBlur.bind(this)} />
            <span className='multi'> X </span>
            <Inline spacing={0} block>
              <Text size='s' className='count' name='partCount' id={id} value={partCount} placeholder={translation('385')} onChange={change.bind(this)} onBlur={onBlur.bind(this)} />
              <Text size='s' className='price spare' name='price' id={id} value={cost} placeholder={currencyText} onChange={change.bind(this)} onBlur={onBlur.bind(this)} />
            </Inline>
          </Grid>
          <Divider noLine />
        </div>
      )
    }
    const mapInputs = (value, key) => {
      // let { inputs } = this.state
      let task = value // this.findTask(inputs, Number(value.OrderTaskId))
      var id = part + '_' + task.OrderTaskId
      let isSpecial = task.OrderTaskId >= this.manualTaskId || (task.TaskPriceId === 0 && !task.FromOrderPrice)
      var textVal = task.TaskName
      let isSelected = task.IsSelected
      // let specialClassName = isSpecial ? 'carSpecialText' : ''
      // specialClassName += ' row clearfix newcarrow'
      let labelText = isSpecial ? '' : task.TaskName
      let inputName = id + '_text'
      let ae = task.AE
      let cost = task.Gross
      let idkey = '' + task.OrderTaskId
      // let widthLeft = ' sixty'
      // let widthRight = ' fourty'
      // let leftClass = 'leftcontent' + widthLeft
      // let rightClass = 'rightcontent' + widthRight
      // DecimalInput instead of Text
      return (
        <Grid key={idkey} align='center' spacing={1} cols={[1.25, 0.75]}>
          {isSpecial ? (
            <Inline block alignChildren='center' spacing={0}>
              <Check simple name={id} id={id} value={isSelected} checked={isSelected} onChange={checkChange} onClick={click} />
              <Text size='s' name={inputName} id={inputName} value={textVal} placeholder={translation('227')} onChange={change.bind(this)} onBlur={onBlur.bind(this)} />
            </Inline>
            ) : (<Check spacing={0} labelText={labelText} name={id} id={id} value={isSelected} checked={isSelected} onChange={checkChange} onClick={click} />)}
          {!this.props.isPaint && <Inline spacing={0}>
            <Text size='s' name='ae' id={id} value={ae} placeholder={translation('13345')} onChange={change.bind(this)} onBlur={onBlur.bind(this)} />
            <Text size='s' name='price' id={id} value={cost} placeholder={currencyText} onChange={change.bind(this)} onBlur={onBlur.bind(this)} />
          </Inline>}
        </Grid>
      )
    }
    const submit = () => {
      let details = JSON.parse(JSON.stringify(this.state.inputs))
      let toSubmit = []
      for (let key in details) {
        let task = details[key]
        task.name = this.state.selectedBodyPart + '_' + task.OrderTaskId + '_text'
        if (!this.props.isPaint) {
          if (task.SparePartPrice === null) task.SparePartPrice = 0
          if (task.AE === null) task.AE = 0
          if (task.Gross === null) task.Gross = 0
          task.SparePartPrice = parseFloat(reverseFormatCurrency(task.SparePartPrice))
          task.AE = parseFloat(reverseFormatCurrency(task.AE))
          task.Gross = parseFloat(reverseFormatCurrency(task.Gross))
          task.Net = task.Gross
        }
        if (task.IsSelected === false && task.OrderTaskId < 9000000000000000 && this.state.orderTasks.filter((t) => task.OrderTaskId === t.OrderTaskId).length === 1) {
          // console.log('not selected task', task)
          task.IsDeleted = true
        } else {
          if (task.IsNew === true) {
            task.OrderTaskId = 0
          }
        }
        if (task.IsSelected === true || task.IsDeleted === true) {
          toSubmit.push(task)
        }
      }
      this.props.setCarSelectedParts(toSubmit)
      this.close()
    }
    let notSpares = this.state.inputs.filter((val, index) => {
      return !val.IsSparePart
    })

    let isSpares = this.state.inputs.filter((val, index) => {
      return val.IsSparePart
    })
    // {renderLineHeading('/images/svgs/pricecalculation/workflow.svg', '14852')}
    // {renderLineHeading('/images/svgs/pricecalculation/spare-parts.svg', '14853')}
    return (
      <div>
        {this.props.price.Department === 1 && [
          <PanelHeader key='1' text={(<Inline spacing={0} block alignChildren='center'><Icon icon={ElementIcons.Workflow} />{translation('14852')}</Inline>)} />,
          <Divider key='2' />
        ]}
        {renderHeadings()}
        <div className='taskslist'>
          {notSpares.map(mapInputs)}
        </div>
        {this.props.price.Department === 1 && [
          <PanelHeader key='5' text={(<Inline spacing={0} block alignChildren='center'><Icon icon={ElementIcons.Spare_Parts} />{translation('14853')}</Inline>)} />,
          <Divider key='6' />
        ]}
        {renderPartHeadings()}
        {isSpares.map(mapSpareInputs)}

        <Divider size={3} noLine />
        <Button onClick={submit} labelText={translation('1208')} />
      </div>
    )
  }
  close () {
    this.reset(this.props)
    this.props.close()
  }
}
ExtentList.defaultProps = {
}
ExtentList.propTypes = {
  isPaint: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired
}
ExtentList.contextTypes = {
  // t: React.PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    price: state.price.price,
    order: state.orders.order,
    showPopupForParts: state.price.showPopupForParts,
    selectedBodyPart: state.price.selectedBodyPart,
    selectedBodyPartSide: state.price.selectedBodyPartSide,
    carParts: state.price.carParts,
    carPriceParts: state.price.carPriceParts,
    carSelectedParts: state.price.carSelectedParts,
    currencyCode: state.common.currencyCode
  }
}

export default connect(mapStateToProps, {
  showPopupParts,
  setCarSelectedParts
})(ExtentList)



// WEBPACK FOOTER //
// ./src/app/shared/components/Car/CarPopup/ExtentList/index.js